import { createPortal } from "react-dom";

/**
 * Confirmation when a participant email already exists (same company or another company).
 */
export default function DuplicateEmailConfirmDialog({
  open,
  email = "",
  otherCompanies = [],
  targetCompanyName = "",
  username = "",
  confirmationReason = "other_company",
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open || typeof document === "undefined") return null;

  const isSameCompany = confirmationReason === "same_company";
  const existingAt = isSameCompany
    ? targetCompanyName || "this company"
    : otherCompanies.length > 0
      ? otherCompanies.join(", ")
      : "another company";

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-600/50 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="duplicate-email-title"
    >
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 text-center">
        <h3 id="duplicate-email-title" className="text-xl font-semibold text-[#004f73] mb-3">
          Are you sure you want to proceed?
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-2">
          {username ? (
            <>
              <span className="font-semibold text-gray-800">{username}</span> (
              <span className="font-semibold text-[#004f73]">{email}</span>)
            </>
          ) : (
            <span className="font-semibold text-[#004f73]">{email}</span>
          )}{" "}
          {isSameCompany ? (
            <>
              has already been invited to{" "}
              <span className="font-semibold text-gray-800">{existingAt}</span>.
            </>
          ) : (
            <>
              is already associated with{" "}
              <span className="font-semibold text-gray-800">{existingAt}</span>.
            </>
          )}
        </p>
        {isSameCompany ? (
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Sending again will create a new assessment invite for this person at{" "}
            <span className="font-semibold text-gray-800">
              {targetCompanyName || "this company"}
            </span>
            .
          </p>
        ) : targetCompanyName ? (
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Continuing will also invite them to{" "}
            <span className="font-semibold text-gray-800">{targetCompanyName}</span>.
          </p>
        ) : (
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Continuing will also invite them to this company.
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            className="blue_btn text-sm min-w-[7rem] disabled:opacity-50"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? "Please wait…" : "Yes, Invite"}
          </button>
          <button
            type="button"
            className="grey_btn text-sm min-w-[7rem]"
            disabled={busy}
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
